// lib/firebase/config.ts
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { isNativePlatform } from '../capacitor/platform';

export const firebaseConfig = {
  apiKey: "AIzaSyCrpxHdAygoWi7sHUsZwe6sSmQli_WIddY",
  authDomain: "planifai-3b86e.firebaseapp.com",
  projectId: "planifai-3b86e",
  storageBucket: "planifai-3b86e.firebasestorage.app",
  messagingSenderId: "1091862867172",
  appId: "1:1091862867172:web:20d60afa898c6ef983d0f1",
  measurementId: "G-Z5NDKNZKK0"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Configurar persistencia local
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });

// Enable auth emulator in development
if (import.meta.env.DEV && !isNativePlatform()) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');
}